import request from '../utils/request'

/**
 * 项目相关API
 */

// 获取当前用户的项目列表（不分页）
export function getMyProjectList() {
  return request({
    url: '/project/list/my',
    method: 'get'
  })
}

// 获取项目列表（分页）
export function getProjectListPaged(params) {
  return request({
    url: '/project/list/paged',
    method: 'get',
    params
  })
}

// 获取项目详情
export function getProjectDetail(id) {
  return request({
    url: `/project/${id}`,
    method: 'get'
  })
}

// 创建项目
export function createProject(data) {
  return request({
    url: '/project',
    method: 'post',
    data
  })
}

// 更新项目
export function updateProject(id, data) {
  return request({
    url: `/project/${id}`,
    method: 'put',
    data
  })
}

// 删除项目
export function deleteProject(id) {
  return request({
    url: `/project/${id}`,
    method: 'delete'
  })
}

// 获取项目成员列表
export function getProjectMembers(id) {
  return request({
    url: `/project/${id}/members`,
    method: 'get'
  })
}

// 添加项目成员
export function addProjectMember(id, data) {
  return request({
    url: `/project/${id}/members`,
    method: 'post',
    data
  })
}

// 移除项目成员
export function removeProjectMember(id, memberId) {
  return request({
    url: `/project/${id}/members/${memberId}`,
    method: 'delete'
  })
}

export default {
  getMyProjectList,
  getProjectListPaged,
  getProjectDetail,
  createProject,
  updateProject,
  deleteProject,
  getProjectMembers,
  addProjectMember,
  removeProjectMember
}
